import React from "react";
import { FaArrowRightArrowLeft, FaDatabase, FaLayerGroup } from "react-icons/fa6";
import banner2 from "../assets/banner2.jpg";

export default function ElectricalInstallations() {
  const features = [
    {
      icon: <FaLayerGroup size={20} className="text-primary" />,
      text: "Integration of business applications, operational platforms, and cross-functional workflows.",
    },
    {
      icon: <FaDatabase size={20} className="text-primary" />,
      text: "Improved data movement between systems to reduce duplication and fragmented reporting.",
    },
    {
      icon: <FaArrowRightArrowLeft size={20} className="text-primary" />,
      text: "Connected digital environments that help teams collaborate more effectively and work with fewer silos.",
    },
  ];

  return (
    <section className="MainBodySection service-detail-page">
      <div className="container service-detail-shell">
        <div className="text-center">
          <div className="section-kicker mb-3">Service Detail</div>
          <h2 className="main-section-title">Systems Integration</h2>
          <p className="section-copy">
            Nova Technologies creates joined-up digital environments where systems,
            workflows, and information work together with less friction.
          </p>
        </div>

        <div className="service-detail-media">
          <img src={banner2} alt="Systems Integration" />
        </div>

        <div className="detail-card">
          <p className="detail-summary mb-4">
            Systems integration helps organizations move beyond isolated tools by aligning
            platforms and processes into a more coordinated operating model. The result is
            stronger visibility, smoother handoffs, and better day-to-day execution.
          </p>

          <ul className="detail-feature-list mb-4">
            {features.map((item) => (
              <li key={item.text} className="detail-feature-item">
                {item.icon}
                <span>{item.text}</span>
              </li>
            ))}
          </ul>

          <ol className="detail-step-list">
            <li>Map the systems and workflows that need to connect.</li>
            <li>Design reliable information flow across teams and functions.</li>
            <li>Implement the integration approach with attention to continuity.</li>
            <li>Refine the environment for usability, reliability, and reporting.</li>
          </ol>
        </div>
      </div>
    </section>
  );
}
